import React from 'react';
import './PrivacyPolicy.css';

const TermsOfService = ({ language }) => {
  const content = {
    sq: {
      title: 'Kushtet e Shërbimit',
      lastUpdated: 'Përditësuar më: 24 Shkurt 2026',
      sections: [
        {
          title: '1. Pranimi i Kushteve',
          content: 'Duke përdorur faqen e internetit të Gjenerali SHPK (gjenerali.al), ju pranoni të respektoni këto kushte të shërbimit. Nëse nuk pajtoheni me këto kushte, ju lutemi mos përdorni faqen tonë.'
        },
        {
          title: '2. Shërbimet Tona',
          content: `Gjenerali SHPK ofron shërbime ndërtimi duke përfshirë:

• Ndërtim shtëpish dhe vilash
• Renovim dhe ristrukturim
• Punime betoni dhe muratorie
• Instalime elektrike dhe hidraulike
• Dizajn dhe projektim
• Konsulencë ndërtimi

Të gjitha shërbimet ofrohen sipas standardeve profesionale dhe ligjeve shqiptare.`
        },
        {
          title: '3. Përdorimi i Faqes',
          content: `Ju pranoni të përdorni këtë faqe vetëm për qëllime të ligjshme:

• Të shikoni informacion për shërbimet tona
• Të kontaktoni kompaninë tonë
• Të kërkoni oferta për projekte
• Të shikoni punët tona të mëparshme

Ju NUK keni të drejtë:
• Të kopjoni përmbajtjen pa leje
• Të përdorni faqen për qëllime të paligjshme
• Të dëmtoni ose ndërprisni funksionimin e faqes
• Të përdorni bota ose skripte automatike`
        },
        {
          title: '4. Pronësia Intelektuale',
          content: `Të gjitha përmbajtjet në këtë faqe janë pronë e Gjenerali SHPK:

• Fotot e projekteve
• Tekstet dhe përshkrimet
• Logoja dhe dizajni
• Kodet dhe softueri

Kopjimi, riprodhimi ose shpërndarja pa leje është e ndaluar dhe mund të ndiqet ligjërisht.`
        },
        {
          title: '5. Ofertat dhe Çmimet',
          content: `Të gjitha çmimet dhe ofertat në faqe janë:

• Orientuese dhe jo përfundimtare
• Subjekt i ndryshimit pa njoftim
• Të vlefshme vetëm pas konfirmimit me shkrim
• Të bazuara në informacionin e dhënë nga klienti

Çmimi përfundimtar përcaktohet pas inspektimit të vendit dhe diskutimit të detajeve.`
        },
        {
          title: '6. Kufizimi i Përgjegjësisë',
          content: `Gjenerali SHPK nuk mban përgjegjësi për:

• Gabime ose mospërputhje në informacionin e faqes
• Vonesa ose ndërprerje në shërbimin e faqes
• Dëme të shkaktuara nga përdorimi i faqes
• Linqe të jashtme që drejtojnë në faqe të tjera
• Humbje të të dhënave ose informacionit

Përgjegjësia jonë kufizohet në shumën e paguar për shërbimin specifik.`
        },
        {
          title: '7. Garancitë dhe Disclaimer',
          content: `Shërbimet tona ofrohen "siç janë":

• Nuk garantojmë rezultate specifike
• Nuk garantojmë kohë të caktuar përfundimi (pa kontratë)
• Nuk garantojmë çmime pa inspektim
• Garantojmë cilësinë e punës sipas kontratës

Të gjitha garancitë specifikohen në kontratën e nënshkruar.`
        },
        {
          title: '8. Kontrata dhe Marrëveshje',
          content: `Për çdo projekt ndërtimi:

• Nënshkruhet kontratë e shkruar
• Specifikohen të gjitha detajet
• Përcaktohen afatet kohore
• Përcaktohen çmimet dhe kushtet e pagesës
• Përcaktohen garancitë

Kontrata ka përparësi mbi këto kushte të përgjithshme.`
        },
        {
          title: '9. Mbrojtja e të Dhënave',
          content: `Të dhënat tuaja personale:

• Mbrohen sipas GDPR
• Përdoren vetëm për qëllimet e deklaruara
• Nuk ndahen me palë të treta
• Mund të fshihen me kërkesë

Shihni Politikën e Privatësisë për më shumë detaje.`
        },
        {
          title: '10. Ligji Aplikues',
          content: `Këto kushte rregullohen nga:

• Ligjet e Republikës së Shqipërisë
• Gjykatat e Durrësit kanë juridiksion
• Gjuha shqipe ka përparësi në rast mosmarrëveshjeje

Çdo mosmarrëveshje zgjidhet fillimisht me negociata, pastaj me gjykatë.`
        },
        {
          title: '11. Ndryshimet në Kushte',
          content: `Gjenerali SHPK rezervon të drejtën:

• Të ndryshojë këto kushte në çdo kohë
• Të përditësojë shërbimet dhe çmimet
• Të ndërpresë shërbimin e faqes për mirëmbajtje

Ndryshimet hyjnë në fuqi menjëherë pas publikimit në faqe.`
        },
        {
          title: '12. Kontakti',
          content: `Për pyetje rreth këtyre kushteve:

Email: altion.basha@gjenerali.al
Telefon: +355 68 209 1156
Adresa: Manëz, Durrës, Shqipëri
Website: https://gjenerali.al

Jemi të disponueshëm për të sqaruar çdo pikëpyetje.`
        }
      ]
    },
    en: {
      title: 'Terms of Service',
      lastUpdated: 'Last Updated: February 24, 2026',
      sections: [
        {
          title: '1. Acceptance of Terms',
          content: 'By using the Gjenerali SHPK website (gjenerali.al), you agree to comply with these terms of service. If you do not agree with these terms, please do not use our website.'
        },
        {
          title: '2. Our Services',
          content: `Gjenerali SHPK provides construction services including:

• House and villa construction
• Renovation and restructuring
• Concrete and masonry work
• Electrical and plumbing installations
• Design and planning
• Construction consulting

All services are provided according to professional standards and Albanian laws.`
        },
        {
          title: '3. Website Use',
          content: `You agree to use this website only for lawful purposes:

• View information about our services
• Contact our company
• Request quotes for projects
• View our previous work

You may NOT:
• Copy content without permission
• Use the site for illegal purposes
• Damage or disrupt site functionality
• Use bots or automated scripts`
        },
        {
          title: '4. Intellectual Property',
          content: `All content on this website is property of Gjenerali SHPK:

• Project photos
• Texts and descriptions
• Logo and design
• Code and software

Copying, reproduction, or distribution without permission is prohibited and may be prosecuted.`
        },
        {
          title: '5. Quotes and Pricing',
          content: `All prices and quotes on the website are:

• Indicative and not final
• Subject to change without notice
• Valid only after written confirmation
• Based on information provided by client

Final pricing is determined after site inspection and discussion of details.`
        },
        {
          title: '6. Limitation of Liability',
          content: `Gjenerali SHPK is not responsible for:

• Errors or inaccuracies in website information
• Delays or interruptions in website service
• Damages caused by website use
• External links to other websites
• Loss of data or information

Our liability is limited to the amount paid for the specific service.`
        },
        {
          title: '7. Warranties and Disclaimer',
          content: `Our services are provided "as is":

• We do not guarantee specific results
• We do not guarantee completion times (without contract)
• We do not guarantee prices without inspection
• We guarantee work quality per contract

All warranties are specified in the signed contract.`
        },
        {
          title: '8. Contracts and Agreements',
          content: `For every construction project:

• Written contract is signed
• All details are specified
• Timelines are defined
• Prices and payment terms are set
• Warranties are defined

The contract takes precedence over these general terms.`
        },
        {
          title: '9. Data Protection',
          content: `Your personal data:

• Protected under GDPR
• Used only for stated purposes
• Not shared with third parties
• Can be deleted upon request

See Privacy Policy for more details.`
        },
        {
          title: '10. Governing Law',
          content: `These terms are governed by:

• Laws of the Republic of Albania
• Courts of Durres have jurisdiction
• Albanian language takes precedence in case of dispute

Any dispute is resolved first through negotiation, then through court.`
        },
        {
          title: '11. Changes to Terms',
          content: `Gjenerali SHPK reserves the right to:

• Change these terms at any time
• Update services and pricing
• Suspend website service for maintenance

Changes take effect immediately upon publication on the website.`
        },
        {
          title: '12. Contact',
          content: `For questions about these terms:

Email: altion.basha@gjenerali.al
Phone: +355 68 209 1156
Address: Manëz, Durres, Albania
Website: https://gjenerali.al

We are available to clarify any questions.`
        }
      ]
    }
  };

  const text = content[language] || content.sq;

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>{text.title}</h1>
        <p className="last-updated">{text.lastUpdated}</p>
        
        {text.sections.map((section, index) => (
          <div key={index} className="privacy-section">
            <h2>{section.title}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>{section.content}</p>
          </div>
        ))}

        <div className="privacy-footer">
          <p>© 2026 Gjenerali SHPK. Të gjitha të drejtat e rezervuara.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
